import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SubmitBtn from 'src/component/ActionBtn/SubmitBtn'
import Field from 'src/component/field'
import NotesFileRequest from './NotesFileRequest'
import { errorToaster } from 'src/utils'

const ReturnPrescRequest = () => {

    const [requestNumber, setRequestNumber] = useState<string>("")
    const handleSubmitModal = useRef<any>("")

    const { t } = useTranslation()

    const handleOpenModal = () => {
        if (!requestNumber) return errorToaster("request-id-alert")
        handleSubmitModal.current.click()
    }

    return (
        <>
            <NotesFileRequest modalID={handleSubmitModal} recordID={requestNumber} />
            <div className='full-height'>
                <div className="pharmacy-section">
                    <h3 className="text-lg font-semibold">{t("add-request-number")}</h3>
                    <Field id={"req-number"} label={"req-number"} value={requestNumber} setValue={(value: string) => setRequestNumber((prev: string) => value)} />
                        <br/>
                    <SubmitBtn onSubmit={handleOpenModal} label={"return-request"} />
                </div>
            </div>
        </>
    )
}

export default ReturnPrescRequest